import type { SVGProps } from 'react';
const SvgCategory = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#category_svg__a)">
      <path d="m12 2-5.5 9h11L12 2ZM17.5 22a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM3 13.5h8v8H3v-8Z" />
    </g>
    <defs>
      <clipPath id="category_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCategory;
